import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "menu-item-tools",
  "use": "menu-item-tools-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"menu-item-tools\"><path clip-rule=\"evenodd\" d=\"M17 5h3v3H4V5h3l1.2-4h7.5zm-4 12v6h-2v-6H9l-1-7h8l-1 7z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol